module.exports = __webpack_public_path__ + "img/voice.5f627326.png";